import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = {
  key: 0,
  class: "card-title"
}
const _hoisted_4 = { class: "bf-price-original" }
const _hoisted_5 = { class: "bf-price-discounted" }
const _hoisted_6 = {
  key: 1,
  class: "card-title"
}
const _hoisted_7 = { class: "card-text" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "card-footer bg-transparent"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "card-footer" }, [
  /*#__PURE__*/_createElementVNode("small", null, [
    /*#__PURE__*/_createElementVNode("i", null, "Gültig für alle Kurstermine dieses Kurses.")
  ])
], -1)
const _hoisted_14 = { class: "card-header" }
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = {
  key: 0,
  class: "card-title"
}
const _hoisted_17 = { class: "bf-price-original" }
const _hoisted_18 = { class: "bf-price-discounted" }
const _hoisted_19 = {
  key: 1,
  class: "card-title"
}
const _hoisted_20 = {
  key: 2,
  class: "card-text"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Laufzeit")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("small", null, "Trainiere so oft du willst!", -1)
const _hoisted_24 = {
  key: 3,
  class: "card-text"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("small", null, "Trainiere so flexibel wie möglich!", -1)
const _hoisted_27 = {
  key: 4,
  class: "card-text"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" – ")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("small", null, "Trainiere so oft du willst!", -1)
const _hoisted_31 = {
  key: 0,
  class: "card-footer bg-transparent"
}
const _hoisted_32 = { class: "card-footer" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", null, "Gültig im angegebenen Zeitraum.", -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card text-center", this.classes])
  }, [
    (_ctx.product.type === 2)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("b", null, _toDisplayString(_ctx.courseProduct.type_human), 1)
          ]),
          _createElementVNode("div", _hoisted_2, [
            (_ctx.showPrice)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_3, [
                  (!_ctx.hasDiscount)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.formatPrice(_ctx.courseProduct.price)), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.formatPrice(_ctx.courseProduct.price)), 1),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formatPrice(_ctx.discountedPrice)), 1)
                      ], 64))
                ]))
              : _createCommentVNode("", true),
            (_ctx.showRegion && _ctx.product.region?.name)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_6, _toDisplayString(_ctx.product.region.name), 1))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_7, [
              _createElementVNode("b", null, _toDisplayString(_ctx.courseProduct.course.course_type.name), 1),
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.courseProduct.course.weekday_label), 1),
              _hoisted_9,
              (_ctx.courseProduct.course.appointments_count)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.courseProduct.course.appointments_count) + " Termine – ", 1))
                : _createCommentVNode("", true),
              _createTextVNode(" Start " + _toDisplayString(_ctx.formatDate(_ctx.courseProduct.course.appointment_first.start)), 1),
              _hoisted_11,
              _createElementVNode("small", null, _toDisplayString(_ctx.courseProduct.course.region.name), 1)
            ])
          ]),
          (_ctx.enableOrderButton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-primary",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onOrderButtonClick && _ctx.onOrderButtonClick(...args)), ["prevent"]))
                }, _toDisplayString(_ctx.orderButtonLabel || 'Jetzt buchen'), 1)
              ]))
            : _createCommentVNode("", true),
          _hoisted_13
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("b", null, _toDisplayString(_ctx.generalProduct.custom_title ? _ctx.generalProduct.custom_title : _ctx.generalProduct.type_human), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_ctx.showPrice)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_16, [
                  (!_ctx.hasDiscount)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.formatPrice(_ctx.generalProduct.price)), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatPrice(_ctx.generalProduct.price)), 1),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.formatPrice(_ctx.discountedPrice)), 1)
                      ], 64))
                ]))
              : _createCommentVNode("", true),
            (_ctx.showRegion && _ctx.product.region?.name)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_19, _toDisplayString(_ctx.product.region.name), 1))
              : _createCommentVNode("", true),
            (_ctx.generalProduct.type === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.expirationHuman(_ctx.generalProduct)), 1),
                  _hoisted_21,
                  _hoisted_22,
                  _hoisted_23
                ]))
              : (_ctx.generalProduct.type === 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.generalProduct.configuration.quantity), 1),
                    _createTextVNode(" Trainingseinheit" + _toDisplayString(_ctx.generalProduct.configuration.quantity !== 1 ? 'en' : ''), 1),
                    _hoisted_25,
                    _hoisted_26
                  ]))
                : (_ctx.generalProduct.type === 3)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.formatDate(_ctx.generalProduct.configuration.valid_from)), 1),
                      _hoisted_28,
                      _createElementVNode("b", null, _toDisplayString(_ctx.formatDate(_ctx.generalProduct.configuration.valid_to)), 1),
                      _hoisted_29,
                      _hoisted_30
                    ]))
                  : _createCommentVNode("", true)
          ]),
          (_ctx.enableOrderButton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-primary",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onOrderButtonClick && _ctx.onOrderButtonClick(...args)), ["prevent"]))
                }, _toDisplayString(_ctx.orderButtonLabel || 'Jetzt kaufen'), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_32, [
            (_ctx.generalProduct.type === 3)
              ? (_openBlock(), _createElementBlock("small", _hoisted_33, _hoisted_35))
              : (_openBlock(), _createElementBlock("small", _hoisted_36, [
                  _createElementVNode("i", null, _toDisplayString(_ctx.expirationHuman(_ctx.generalProduct)) + " gültig ab Kaufdatum.", 1)
                ]))
          ])
        ], 64)),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}